<template>
  <div :class="componentClassName">
    <a-page-heading>契約情報確認・変更</a-page-heading>
    <div v-if="fetchedCompanyIDListFlag" class="t-contract-list">
      <a-select-field
        v-if="showSelect"
        id="companySearch"
        ref="companySearch"
        v-model="selectedCompanyID"
        :options="companyIDList"
        :searchable="true"
      />
    </div>
    <m-section v-if="fetchedCompanyIDListFlag" v-show="detailShowFlag">
      <m-action-card :id="idName[1]" title="契約者情報" header-border no-header-margin icon="user">
        <template #action>
          <a-button
            v-if="selectedCompanyID !== POINT && canEdit"
            id="mailApply"
            :inline="true"
            variant="round"
            color="grey"
            size="small"
            icon="edit"
            label="ID（メールアドレス）変更"
            title="契約者権限ユーザーのID（メールアドレス）変更"
            @click="handleMailChangeClick"
          />&nbsp;
          <a-button
            v-if="canEdit"
            id="edit"
            :inline="true"
            variant="round"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="handleEditContractor"
          />
        </template>
        <!--
        <m-data-list :data="contractorData" align-right />
        -->
        <m-data-list id="contractData" :data="contractData" align-right />
      </m-action-card>
    </m-section>

    <m-section v-if="businessType === 'company' && fetchedCompanyIDListFlag" v-show="detailShowFlag">
      <m-action-card :id="idName[2]" title="法人情報" header-border no-header-margin icon="file">
        <m-data-list id="contractDataHoujin" :data="contractDataHoujin" align-right />
      </m-action-card>
    </m-section>

    <m-section v-if="fetchedCompanyIDListFlag" v-show="detailShowFlag">
      <m-action-card :id="idName[3]" title="請求書送付先" header-border no-header-margin icon="credit-card">
        <m-data-list id="invoiceData" :data="invoiceData" align-right />
      </m-action-card>
    </m-section>

    <m-section v-if="fetchedCompanyIDListFlag" v-show="detailShowFlag">
      <m-action-card :id="idName[5]" title="登録ユーザー" header-border no-header-margin icon="register">
        <template #action>
          <!--
          <a-button
            :inline="true"
            variant="round"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="handleEditRegister"
          />
          -->
        </template>
        <m-data-list id="registerData" :data="registerData" variant="long" />
      </m-action-card>
    </m-section>

    <m-section v-show="detailShowFlag && sfAvailable">
      <m-action-card :id="idName[6]" title="Salesforce連携設定" header-border no-header-margin icon="user">
        <template #action>
          <a-button
            id="editSfSetting"
            :inline="true"
            variant="round"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="handleEditSfSetting"
          />
        </template>
      </m-action-card>
    </m-section>

    <m-section>
      <!--
      <m-action-card title="支払い方法" header-border no-header-margin icon="credit-card">
        <template #action>
          <a-button
            :inline="true"
            variant="round"
            color="grey"
            size="small"
            icon="edit"
            label="編集"
            @click="handleEditPaymentMethod"
          />
        </template>
        <m-data-list :data="paymentMethodData" variant="long" />
      </m-action-card>
      -->
    </m-section>

    <!--
    <a-button
      class="t-contract-list__button-cancel-setting"
      variant="text"
      target="blank"
      :inline="true"
      underline
      :href="cancelUrl"
      color="red"
      label="このアカウントを解約する"
    />
    -->
    <a-button
      v-if="canCancel && fetchedCompanyIDListFlag"
      id="cancel"
      class="t-contract-list__button-cancel-setting"
      variant="text"
      target="blank"
      :inline="true"
      underline
      color="red"
      label="このアカウントを解約する"
      :disabled="!flagCancelButtonEnable"
      @click="handleCancelClick"
    />
  </div>
  <teleport to="body">
    <o-modal
      id="ContractList_resultModal"
      v-model:visible="resultModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="450px"
      z-index="9998"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ resultModalTitle }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="resultModalContent" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button id="ok" variant="block" color="primary" label="OK" size="small" @click="handleCloseModal(next)" />
      </template>
    </o-modal>
  </teleport>
  <teleport to="body">
    <o-modal
      id="ContractEditContractorInfo_confirmModal3"
      v-model:visible="mailChangeModalVisible"
      class="o-modal-remove-phone-number-confirmation"
      footer-variant="confirmation"
      width="442px"
      z-index="9998"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ mailChangeModalTitle }}</template>
      <template v-if="confChoice === 0">
        <p>変更方法を選択してください。</p>
        <br />
        <a-radio
          id="modificationType1"
          v-model="radioValue"
          class="t-contract-edit-contractor-info__modification-type"
          name="modificationType"
          value="0"
          label="新しいメールアドレスに変更する"
          checked
        />
        <a-radio
          id="modificationType2"
          v-model="radioValue"
          class="t-contract-edit-contractor-info__modification-type"
          name="modificationType"
          value="1"
          label="既存のID(メールアドレス)に契約者権限を移譲する"
        />
      </template>
      <template v-if="confChoice === 1 && radioValue === '0'">
        <p>新しいメールアドレスを入力してください。</p>
        <br />
        <a-text-field id="confEmail" v-model="modificationEmail" type="email" maxlength="50" />
      </template>
      <template v-if="confChoice === 2">
        <p v-if="companyID !== POINT">
          以下のメールアドレスに認証コードを送信します。アドレスに誤りがないことを確認し次へをクリックしてください。
        </p>
        <p v-if="companyID === POINT">
          以下のメールアドレスに変更します。アドレスに誤りがないことを確認し次へをクリックしてください。
        </p>
        <br />
        {{ modificationEmail }}
      </template>
      <template v-if="confChoice === 3">
        <p>メールアドレスへ送信したコードを入力してください。入力が完了すると自動的にログアウトされます。</p>
        <br />
        <a-text-field id="inputCode" v-model="inputCode" type="text" maxlength="6" />
      </template>
      <template v-if="confChoice === 4">
        <p>新しい契約者権限ユーザーのメールアドレスを選択してください。</p>
        <br />
        <m-form-input label="" class="t-setting-ivr-edit__setting-group-name">
          <a-select-field id="selectEmail" v-model="selectEmailValue" :options="selectEmail" />
        </m-form-input>
      </template>
      <template v-if="confChoice === 5">
        <p>契約者権限の移譲を行います。<br />よろしければOKをクリックしてください。</p>
        <p>※両ユーザーとも自動的にログアウトされます<br />※通話中の場合は切断されますのでご注意ください</p>
        <br />
        <p>
          <strong>新しい契約者権限ユーザー</strong><br />{{ selectEmailValue }} <br /><br />
          <strong>{{ changeAuthInfo }}に変更</strong><br />{{ formData.adminEmail }}
        </p>
      </template>
      <template #footer>
        <template v-if="confChoice < 2">
          <a-button
            id="profileModalCloseButton"
            variant="outlined"
            color="primary"
            label="キャンセル"
            size="small"
            @click="handleMailChangeCloseModal"
          />
        </template>
        <template v-if="confChoice === 0 && radioValue === '0'">
          <a-button
            id="profileModalCloseButton"
            variant="block"
            color="primary"
            label="次へ"
            size="small"
            @click="handleNewMailChangeClick"
          />
        </template>
        <template v-if="confChoice === 0 && radioValue === '1'">
          <a-button
            id="profileModalCloseButton"
            variant="block"
            color="primary"
            label="次へ"
            size="small"
            @click="handleTransferAuthorityClick"
          />
        </template>
        <template v-if="confChoice === 1">
          <a-button
            id="profileModalCloseButton"
            variant="block"
            color="primary"
            label="次へ"
            size="small"
            @click="handleRegistMailCheckClick"
          />
        </template>
        <template v-if="confChoice === 2">
          <a-button
            id="profileModalBackButton"
            variant="outlined"
            color="primary"
            label="戻る"
            size="small"
            @click="handleNewMailChangeClick"
          />
          <a-button
            v-if="companyID !== POINT"
            id="profileModalCloseButton"
            variant="block"
            color="primary"
            label="次へ"
            size="small"
            @click="handleSendCodeClick"
          />
          <a-button
            v-if="companyID === POINT"
            id="profileModalOkButton"
            variant="block"
            color="primary"
            label="次へ"
            size="small"
            @click="handleInputCodeClick"
          />
        </template>
        <template v-if="confChoice === 3">
          <a-button
            id="profileModalOkButton"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleInputCodeClick"
          />
        </template>
        <template v-if="confChoice === 4">
          <a-button
            id="profileModalBackButton"
            variant="outlined"
            color="primary"
            label="戻る"
            size="small"
            @click="handleBackMailChangeClick"
          />
          <a-button
            id="profileModalCloseButton"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleTransferAuthorityConfClick"
          />
        </template>
        <template v-if="confChoice === 5">
          <a-button
            id="profileModalBackButton"
            variant="outlined"
            color="primary"
            label="戻る"
            size="small"
            @click="handleTransferAuthorityClick"
          />
          <a-button
            id="profileModalCloseButton"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleAdminTransferClick"
          />
        </template>
      </template>
    </o-modal>
  </teleport>
  <!-- 電話番号管理画面へ遷移するモーダル -->
  <teleport to="body">
    <o-modal
      id="ContractList_confirm"
      v-model:visible="confirmModal.visible"
      class="o-modal-confirm-modal"
      footer-variant="confirmation"
      width="442px"
      z-index="9998"
      :footer-shadow="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <template #title>{{ confirmModal.title }}</template>
      <a-text>
        <!-- eslint-disable -->
        <span v-html="confirmModal.message" />
        <!-- eslint-enable -->
      </a-text>
      <template #footer>
        <a-button
          id="cancel_confirmModal"
          variant="outlined"
          color="primary"
          label="いいえ"
          size="small"
          @click="hideConfirmModal()"
        />
        <a-button
          id="ok_confirmModal"
          variant="block"
          color="primary"
          label="はい"
          size="small"
          @click="confirmModal.action()"
        />
      </template>
    </o-modal>
  </teleport>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import APageHeading from '@/components/atoms/page-heading';
import MActionCard from '@/components/molecules/action-card';
import AButton from '@/components/atoms/button';
import MSection from '@/components/molecules/section';
import MDataList from '@/components/molecules/data-list';

import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { PERMISSIONS_FRONTEND } from '@/libs/constants';
import { POINT } from '@/libs/constants';
import { JOBS } from '@/libs/constants';
import { customValidate } from '@/common/customValidate.js';

import { utils } from '@/common/utils.js';

export default {
  name: 't-contract-list',
  components: {
    APageHeading,
    MSection,
    MActionCard,
    AButton,
    MDataList,
  },
  mixins: [customRequest, messageContent, customValidate],
  props: {
    class: {
      type: String,
      default: '',
    },
    // List
    contractorData: {
      type: Array,
      default: new Array(0),
    },
    // numberData: {
    //   type: Array,
    //   default: new Array(0),
    // },
    // registerData: {
    //   type: Array,
    //   default: new Array(0),
    // },
    paymentMethodData: {
      type: Array,
      default: new Array(0),
    },
    cancelUrl: {
      type: String,
      default: '#',
    },
    // handleEditContractor: {
    //   type: Function,
    //   default: () => {},
    // },
    handleEditNumber: {
      type: Function,
      default: () => {},
    },
    handleEditRegister: {
      type: Function,
      default: () => {},
    },
    handleEditPaymentMethod: {
      type: Function,
      default: () => {},
    },
    companyID: {
      type: String,
      default: '',
    },
    handleLogout: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      contractData: [],
      contractDataHoujin: [],
      invoiceData: [], // #2195
      businessType: '',
      numberData: [],
      registerData: [],
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      selectedCompanyID: '',
      companyIDList: [],
      fetchedCompanyIDListFlag: false,
      authInfo: this.$store.state.user.authInfo,
      POINT,
      flagCancelButtonEnable: true, //#1892
      detailShowFlag: true, // #2328
      userID: this.$store.state.user.userID,
      telNumberEmptyText: '登録されている050番号はありません。',

      // Salesforceの連携先設定用
      sfColumnPhoneNumber: '',
      sfColumnCallSid: '',
      sfColumnMemo: '',
      sfAvailable: false,
      idName: [],
      jobs: [],
      selectEmail: [],
      mailChangeModalTitle: '契約者権限ユーザーのID（メールアドレス）変更',
      mailChangeModalVisible: false,
      confChoice: 0, // メールアドレス変更モーダルの表示パターン値  0:変更方法を選択  1:新しいメールアドレスを入力  2:確認  3:認証コード入力  4:既存ユーザーのメールアドレスを選択  5:既存ユーザーへの権限移譲確認
      modificationEmail: '',
      radioValue: '0', // 0:新しいメールアドレスに変更する  1:既存のID(メールアドレス)に契約者権限を移譲する
      inputCode: '',
      soStatus: '',
      formData: {},
      changeAuthInfo: '',
      authInfoList: [
        { operator: 'オペレーター', soOperator: 'オペレーター（SO）', manager: '管理者', supervisor: 'マスタ管理者' },
      ],
      isFDNDLinking: false, // フリーダイヤル/ナビダイヤルとの連携しているフラグ
      vdxPhonenumberContracting: false, // VoiceDXで契約している電話番号があるかチェック
      vdxFDNDLinking: false, // VoiceDXで利用中番号はFDNDに連携されているかチェック
      confirmModal: {},
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-contract-list');
      return `${baseClassName} ${this.class}`.trim();
    },
    canEdit() {
      // For trial
      if (
        utils.chkTrialCompanyID(this.companyID) ||
        (this.companyID === POINT && utils.chkTrialCompanyID(this.selectedCompanyID))
      ) {
        return false;
      }
      if (this.authInfo === 'supervisor') {
        return true;
      }
      if (this.authInfo === 'manager') {
        if (this.companyID === POINT) {
          if (this.selectedCompanyID === POINT) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
      return PERMISSIONS_FRONTEND['contractedit'][this.authInfo];
    },
    canCancel() {
      // For trial
      if (
        utils.chkTrialCompanyID(this.companyID) ||
        (this.companyID === POINT && utils.chkTrialCompanyID(this.selectedCompanyID))
      ) {
        return false;
      }
      if (this.authInfo === 'supervisor') {
        if (this.selectedCompanyID === POINT) {
          return false;
        } else {
          return true;
        }
      }
      if (this.authInfo === 'manager') {
        if (this.companyID === POINT) {
          if (this.selectedCompanyID === POINT) {
            return false;
          } else {
            return true;
          }
        } else {
          return false;
        }
      }
      return PERMISSIONS_FRONTEND['contractcancel'][this.authInfo];
    },
    // #2328
    showSelect() {
      return this.companyID === POINT && this.companyIDList.length !== 0;
    },
  },
  watch: {
    selectedCompanyID: async function (newValue, oldValue) {
      if (newValue && newValue !== oldValue) {
        if (this.companyID === POINT && this.selectedCompanyID !== this.$route.query.companyID) {
          await this.$router.push({ query: { companyID: this.selectedCompanyID } });
        }
        this.fetchContractDataHandler();
        this.fetchContractUserNumHandler();
      }
      if (!newValue) {
        this.selectedCompanyID = oldValue;
      }
      if (this.selectedCompanyID !== '') {
        this.detailShowFlag = true;
      }
    },
  },
  async created() {
    for (let i = 1; i <= 6; i++) {
      this.idName[i] = 'h4-contract' + i;
    }

    if (this.$route.query.companyID) {
      if (!(this.authInfo === 'operator' && this.$route.query.companyID === POINT)) {
        this.selectedCompanyID = this.$route.query.companyID;
      }
    } else if (this.authInfo !== 'operator') {
      this.selectedCompanyID = this.companyID;
    }
    // POINTでかつoperatorの場合、003300以外の企業のみ閲覧可能
    if (
      this.companyID === POINT &&
      this.authInfo === 'operator' &&
      (this.selectedCompanyID === POINT || this.selectedCompanyID === '')
    ) {
      this.detailShowFlag = false;
    } else {
      this.detailShowFlag = true;
    }
    // #2328
    let invalidFlag = false;
    // soOperatorはメニューではねている=改竄されている
    if (this.authInfo === 'soOperator') {
      invalidFlag = true;
    }
    // POINT以外でログインした企業ID以外が指定されてきた=企業IDが改竄されている
    if (this.companyID !== POINT && this.selectedCompanyID !== this.companyID) {
      invalidFlag = true;
    }
    // POINT以外でかつ権限がoperator=メニューではねられるはずなので改竄疑い
    if (this.companyID !== POINT && this.authInfo === 'operator') {
      invalidFlag = true;
    }
    // ログインがPOINTかつPOINT選択はできないはず=改竄疑い
    if (this.companyID === POINT && this.selectedCompanyID === POINT && this.authInfo === 'operator') {
      invalidFlag = true;
    }
    if (invalidFlag === true) {
      this.$router.push({ path: '/permission-denied' });
      return;
    }

    this.jobs = JOBS;

    if (this.companyID === POINT) {
      this.fetchCompanyIDListHandler();
    } else {
      // 一般企業ログインの場合はcompnayIDListは取得したものとして処理（画面表示のため）
      this.fetchedCompanyIDListFlag = true;
    }

    // Salesforce連携設定ONOFF取得
    await this.postRequest('/callLogClient/getSfPopupAvailable', {})
      .then(e => {
        if (e.status === 'success') {
          this.sfAvailable = e.data.companyInfo.sfAvailable;
        }
      })
      .catch(err => {
        console.error(err);
      });
  },
  methods: {
    handleCloseModal(next) {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';

      if (next) {
        this.$router.go(next);
      }
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    showInfoModal(message, next = '') {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.infoModalTitle;
      this.resultModalContent = message;
      this.next = next;
    },
    fetchCompanyIDListHandler: function () {
      this.postRequest('/companymgmt/getcompanyidlistCCCOnly', {
        withPoint:
          this.companyID === POINT && (this.authInfo === 'supervisor' || this.authInfo === 'manager') ? true : false,
      })
        .then(e => {
          this.companyIDList = e.data;
          this.fetchedCompanyIDListFlag = true;
          if (this.companyID === POINT && this.authInfo === 'operator') {
            this.selectedCompanyID = this.companyIDList[0]['value'];
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('企業一覧の取得'));
        });
    },
    fetchContractDataHandler: async function () {
      await this.postRequest('/contract/getcontractdata', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
        authInfo: this.authInfo ? this.authInfo : '',
      })
        .then(e => {
          this.isFDNDLinking = e.isFDNDLinking;
          this.vdxFDNDLinking = e.vdxFDNDLinking;
          this.vdxPhonenumberContracting = e.vdxPhonenumberContracting;
          const adminBirthDate = e.data.adminBirthDate ? e.data.adminBirthDate.replace(/-/g, '/') : '';
          const startDate = e.data.startDate ? e.data.startDate.replace(/-/g, '/') : '';
          const companyRulerFlag = e.data.companyRulerFlag ? '有' : '無';
          this.soStatus = e.data.soStatus;
          this.formData.adminEmail = e.data.adminEmail;

          let adminJob = e.data.adminJob;
          const found = this.jobs.find(element => element.value === adminJob);
          if (typeof found !== 'undefined') {
            adminJob = found.label;
          }

          this.contractData = [
            {
              label: '氏名',
              content: e.data.view_adminName,
            },
            {
              label: '氏名カナ',
              content: e.data.view_adminKanaName,
            },
            {
              label: '生年月日',
              content: adminBirthDate,
            },
            {
              label: 'メールアドレス',
              content: e.data.adminEmail,
            },
            {
              label: '職業',
              content: adminJob,
            },
            {
              label: '電話番号',
              content: e.data.adminPhoneNumber,
            },
            {
              label: '郵便番号',
              content: e.data.adminPostCode,
            },
            {
              label: '都道府県名',
              content: e.data.adminAddress1,
            },
            {
              label: '市区町村',
              content: e.data.adminAddress2,
            },
            {
              label: '字丁目番地など',
              content: e.data.adminAddress3,
            },
            {
              label: '住所建物など',
              content: e.data.adminAddress4,
            },
            {
              label: '利用目的',
              content: e.data.purposeOfUse,
            },
            {
              label: '利用開始日',
              content: startDate,
            },
          ];

          // #2195
          this.invoiceData = [
            {
              label: '郵便番号',
              content: e.data.invoicePostCode,
            },
            {
              label: '都道府県名',
              content: e.data.invoiceAddress1,
            },
            {
              label: '市区町村',
              content: e.data.invoiceAddress2,
            },
            {
              label: '字丁目番地など',
              content: e.data.invoiceAddress3,
            },
            {
              label: '住所建物など',
              content: e.data.invoiceAddress4,
            },
            {
              label: '送付先名',
              content: e.data.invoiceName,
            },
            {
              label: '送付先名カナ',
              content: e.data.invoiceKanaName,
            },
            {
              label: '電話番号',
              content: e.data.invoicePhoneNumber,
            },
          ];

          this.businessType = e.data.businessType;
          if (this.businessType === 'company') {
            this.contractDataHoujin = [
              {
                label: '契約名義',
                content: e.data.companyName,
              },
              {
                label: '契約名義カナ',
                content: e.data.companyKanaName,
              },
              {
                label: '郵便番号',
                content: e.data.companyPostCode,
              },
              {
                label: '都道府県名',
                content: e.data.companyAddress1,
              },
              {
                label: '市区町村',
                content: e.data.companyAddress2,
              },
              {
                label: '字丁目番地など',
                content: e.data.companyAddress3,
              },
              {
                label: '住所建物など',
                content: e.data.companyAddress4,
              },
              {
                label: '事業内容',
                content: e.data.companyBusinessDetails,
              },
              {
                label: '実質的支配者の有無',
                content: companyRulerFlag,
              },
            ];

            if (e.data.companyRulerFlag) {
              if (e.data.companyRulerName) {
                this.contractDataHoujin.push(
                  {
                    label: '実質的支配者名',
                    content: e.data.companyRulerName,
                  },
                  {
                    label: '実質的支配者住所',
                    content: e.data.companyRulerAddress,
                  },
                  {
                    label: '実質的支配者生年月日',
                    content: e.data.companyRulerBirthDate.replace(/-/g, '/'),
                  },
                  {
                    label: '実質的支配者の法人との関係',
                    content: e.data.companyRelationship,
                  }
                );
              }

              if (e.data.companyRulerName2) {
                this.contractDataHoujin.push(
                  {
                    label: '実質的支配者名2',
                    content: e.data.companyRulerName2,
                  },
                  {
                    label: '実質的支配者住所2',
                    content: e.data.companyRulerAddress2,
                  },
                  {
                    label: '実質的支配者生年月日2',
                    content: e.data.companyRulerBirthDate2.replace(/-/g, '/'),
                  },
                  {
                    label: '実質的支配者の法人との関係2',
                    content: e.data.companyRelationship2,
                  }
                );
              }

              if (e.data.companyRulerName3) {
                this.contractDataHoujin.push(
                  {
                    label: '実質的支配者名3',
                    content: e.data.companyRulerName3,
                  },
                  {
                    label: '実質的支配者住所3',
                    content: e.data.companyRulerAddress3,
                  },
                  {
                    label: '実質的支配者生年月日3',
                    content: e.data.companyRulerBirthDate3.replace(/-/g, '/'),
                  },
                  {
                    label: '実質的支配者の法人との関係3',
                    content: e.data.companyRelationship3,
                  }
                );
              }

              if (e.data.companyRulerName4) {
                this.contractDataHoujin.push(
                  {
                    label: '実質的支配者名4',
                    content: e.data.companyRulerName4,
                  },
                  {
                    label: '実質的支配者住所4',
                    content: e.data.companyRulerAddress4,
                  },
                  {
                    label: '実質的支配者生年月日4',
                    content: e.data.companyRulerBirthDate4.replace(/-/g, '/'),
                  },
                  {
                    label: '実質的支配者の法人との関係4',
                    content: e.data.companyRelationship4,
                  }
                );
              }
            }
          }
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('契約者情報取得'));
        });
    },
    fetchContractUserNumHandler: async function () {
      await this.postRequest('/contract/getcontractusernum', {
        companyID: this.companyID === POINT ? this.$route.query.companyID : this.companyID,
      })
        .then(e => {
          this.registerData = [
            {
              label: e.data.userNum + '人',
            },
          ];
        })
        .catch(err => {
          console.log(err);
          this.showErrorModal(messageContent.requireTry('登録ユーザー取得'));
        });
    },
    handleEditContractor() {
      if (this.companyID === POINT) {
        this.$router.push({ path: '/contract/edit', query: { companyID: this.selectedCompanyID } });
      } else {
        this.$router.push({ path: '/contract/edit' });
      }
    },
    handleCancelClick() {
      if (this.isFDNDLinking) {
        this.showConfirmModal(messageContent.FDNDLinkingWarning, this.goToNumberMgmt);
        return;
      }
      if (this.vdxFDNDLinking) {
        this.showInfoModal(messageContent.VDXFDNDLinking);
        return;
      }
      if (this.vdxPhonenumberContracting) {
        this.showConfirmModal(messageContent.vdxPhonenumberContractingWarning, this.goToCancelContract);
        return;
      }
      this.goToCancelContract();
    },
    goToCancelContract() {
      this.flagCancelButtonEnable = false; //#1892
      if (this.companyID === POINT) {
        this.$router.push({ path: '/contract/cancel', query: { companyID: this.selectedCompanyID } });
      } else {
        this.$router.push({ path: '/contract/cancel' });
      }
    },
    handleEditSfSetting() {
      if (this.companyID === POINT) {
        this.$router.push({ path: '/contract/editSfSetting', query: { companyID: this.selectedCompanyID } });
      } else {
        this.$router.push({ path: '/contract/editSfSetting' });
      }
    },
    handleMailChangeCloseModal() {
      this.mailChangeModalVisible = false;
    },
    handleMailChangeClick() {
      if (this.soStatus !== 'pass') {
        this.showErrorModal(messageContent.contractEdit);
        return;
      }
      this.mailChangeModalVisible = true;
      this.confChoice = 0;
    },
    handleNewMailChangeClick() {
      this.confChoice = 1;
    },
    async handleRegistMailCheckClick() {
      if (this.addressCheck(this.modificationEmail) === null) {
        this.showErrorModal(messageContent.incorrectEmailFormat);
        this.confChoice = 1;
        return;
      }
      // 登録済みアドレスチェック
      await this.postRequest('/contract/chkUserDataIncludingVdx', {
        companyID: this.selectedCompanyID,
        userID: this.modificationEmail,
      })
        .then(e => {
          if (e.status === 'success') {
            // 重複している場合
            if (e.data === false) {
              this.confChoice = 2;
            } else {
              this.showErrorModal(messageContent.alreadyEmail);
              this.confChoice = 1;
            }
          } else {
            this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
            this.confChoice = 1;
          }
        })
        .catch(() => {
          this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
        });
    },
    handleSendCodeClick() {
      this.postRequest('/contract/sendCode', {
        companyID: this.selectedCompanyID,
        sendEmail: this.modificationEmail,
      })
        .then(e => {
          if (e.status === 'success') {
            this.confChoice = 3;
          } else {
            this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
            this.mailChangeModalVisible = false;
          }
        })
        .catch(err => {
          this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
        });
    },
    handleBackMailChangeClick() {
      this.confChoice = 0;
    },
    handleInputCodeClick() {
      this.postRequest('/contract/authCodeCheck', {
        inputCode: this.inputCode,
        updAdminEmail: this.modificationEmail,
      })
        .then(e => {
          if (e.status === 'success') {
            if (this.companyID !== POINT) {
              this.logout();
            } else {
              this.mailChangeModalVisible = false;

              this.showInfoModal(
                this.storeItem(this.mailChangeModalTitle),
                '/contract?companyID=' + this.selectedCompanyID
              );
            }
          } else {
            if (e.errType === 0) {
              this.showErrorModal(messageContent.requireInput('認証コード'));
            } else if (e.errType === 1) {
              this.showErrorModal(messageContent.authCodeErr1);
              this.mailChangeModalVisible = false;
            } else if (e.errType === 2) {
              this.showErrorModal(messageContent.authCodeErr2);
            } else {
              this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
            }
          }
        })
        .catch(err => {
          this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
        });
    },
    handleTransferAuthorityClick() {
      this.postRequest('/contract/getTransferUserList', {
        companyID: this.selectedCompanyID,
      })
        .then(res => {
          this.userList = res.data;
          this.confChoice = 4;
          // プルダウンにデータセット
          this.selectEmail = [];
          this.selectEmail.push({ label: '選択してください', value: '選択してください' });
          for (const id in this.userList) {
            if (
              this.userList[id].userID !== this.formData.adminEmail &&
              typeof this.userList[id].userID !== 'undefined'
            ) {
              this.selectEmail.push({ label: this.userList[id].userID, value: this.userList[id].userID });
            }
          }
          this.selectEmailValue = '選択してください';
        })
        .catch(err => {
          this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
        });
    },
    handleTransferAuthorityConfClick() {
      if (this.selectEmailValue === '選択してください') {
        this.showErrorModal(messageContent.requireChoice('メールアドレス'));
        this.confChoice = 4;
      } else {
        this.postRequest('/contract/setSessionEmail', {
          selectEmail: this.selectEmailValue,
        })
          .then(e => {
            if (e.status === 'success') {
              const userFind = this.userList.find(({ userID }) => userID === this.selectEmailValue);
              this.changeAuthInfo = this.authInfoList[0][userFind.authInfo];
              this.confChoice = 5;
            } else {
              this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
              this.confChoice = 4;
            }
          })
          .catch(err => {
            this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
          });
      }
    },
    handleAdminTransferClick() {
      this.mailChangeModalVisible = false;
      this.formData.adminEmail = this.selectEmailValue;

      this.postRequest('/contract/adminTransfer', {
        updAdminEmail: this.selectEmailValue,
      })
        .then(e => {
          if (e.status === 'success') {
            if (this.companyID !== POINT) {
              this.logout();
            } else {
              this.showInfoModal(
                this.storeItem(this.mailChangeModalTitle),
                '/contract?companyID=' + this.selectedCompanyID
              );
            }
          } else {
            if (e.msg !== '') {
              this.showErrorModal(e.msg);
            } else {
              this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
            }
            this.mailChangeModalVisible = false;
          }
        })
        .catch(err => {
          this.showErrorModal(messageContent.requireTry(this.mailChangeModalTitle));
        });
    },
    logout: function () {
      const self = this;
      this.postRequest('/login/logout').then(data => {
        if (data.status === 'success') {
          self.handleLogout();
          window.location.href = '/login';
        } else if (data.status === 'failed') {
          self.showErrorModal(messageContent.requireTry('ログアウト'));
        }
      });
    },
    showConfirmModal(message, action) {
      this.confirmModal = { visible: true, title: messageContent.infoModalTitle, message, action };
    },
    hideConfirmModal() {
      this.confirmModal = { visible: false };
    },
    goToNumberMgmt() {
      if (this.companyID === POINT) {
        this.$router.push({ name: 'NumberMgmt' });
      } else {
        this.$router.push({ name: 'NumberMgmtGeneral' });
      }
    },
  },
};
</script>
